(function () {
  'use strict';

  var addon = document.getElementById('warranty-addon');
  if (!addon) return;

  var checkbox = document.getElementById('warranty-addon-checkbox');
  var priceEl = document.getElementById('warranty-addon-price');
  var variants = JSON.parse(addon.dataset.warrantyVariants || '[]');
  // Works inside Dawn's <product-form> as well as the classic landing-page form.
  var productForm = addon.closest('product-form');
  var form =
    (productForm && productForm.querySelector('form[action*="/cart/add"]')) ||
    addon.closest('form[action*="/cart/add"]') ||
    document.querySelector('form[action*="/cart/add"]');

  if (!form || !checkbox || !variants.length) return;

  // The PDP product shows the checkbox via tag; make sure the cart sync
  // counts it as a charger even before any page reload.
  if (window.ClutchWarrantySync && addon.dataset.productId) {
    window.ClutchWarrantySync.addEligibleProduct(addon.dataset.productId);
  }

  function getQty() {
    var qtyInput = form.querySelector('input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function matchVariant() {
    var tier = window.ClutchWarrantySync
      ? window.ClutchWarrantySync.getRequiredTier(getQty())
      : Math.min(getQty(), variants.length);
    var idx = tier - 1;
    return variants[idx] || variants[variants.length - 1];
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function' && window.Shopify.money_format) {
      return Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshPrice() {
    if (!priceEl) return;
    priceEl.textContent = formatMoney(matchVariant().price);
  }

  form.addEventListener('change', refreshPrice);
  form.addEventListener('click', function () {
    window.setTimeout(refreshPrice, 50);
  });
  refreshPrice();

  form.addEventListener('submit', function () {
    window.pendingPdpWarrantyAttach = checkbox.checked;
  });
})();
